module.exports = __webpack_public_path__ + "img/user.ca7a4e23.png";